import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=2aaf1f3a&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style1 from "./Logo.vue?vue&type=style&index=1&id=2aaf1f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf1f3a",
  null
  
)

export default component.exports